export default {"src":"https://frontends.udemycdn.com/frontends-marketplace-experience/_next/static/media/itAndSoftware.eda37bee.svg","height":24,"width":24};